export const PERIODIC_TABLE_COLUMNS = 18;
export const PERIODIC_TABLE_ROWS = 10; // 7 periods, a spacer row, then lanthanides and actinides

const LANTHANIDE_RANGE = [57, 71];
const ACTINIDE_RANGE = [89, 103];
const LANTHANIDE_ROW = 9;
const ACTINIDE_ROW = 10;
const F_BLOCK_FIRST_COLUMN = 3;

function isInRange(value, [first, last]) {
  return value >= first && value <= last;
}

/**
 * Where an element sits in the standard 18-column periodic table layout.
 * Rows and columns are 1-based, ready for CSS grid.
 */
export function getPeriodicTablePosition(atomicNumber) {
  if (isInRange(atomicNumber, LANTHANIDE_RANGE)) {
    return { row: LANTHANIDE_ROW, column: F_BLOCK_FIRST_COLUMN + atomicNumber - LANTHANIDE_RANGE[0] };
  }
  if (isInRange(atomicNumber, ACTINIDE_RANGE)) {
    return { row: ACTINIDE_ROW, column: F_BLOCK_FIRST_COLUMN + atomicNumber - ACTINIDE_RANGE[0] };
  }
  if (atomicNumber === 1) return { row: 1, column: 1 };
  if (atomicNumber === 2) return { row: 1, column: 18 };
  if (atomicNumber <= 18) {
    const periodStart = atomicNumber <= 10 ? 3 : 11;
    const offset = atomicNumber - periodStart;
    return { row: atomicNumber <= 10 ? 2 : 3, column: offset < 2 ? offset + 1 : offset + 11 };
  }
  if (atomicNumber <= 54) {
    const periodStart = atomicNumber <= 36 ? 19 : 37;
    return { row: atomicNumber <= 36 ? 4 : 5, column: atomicNumber - periodStart + 1 };
  }
  const periodStart = atomicNumber <= 86 ? 55 : 87;
  const row = atomicNumber <= 86 ? 6 : 7;
  const offset = atomicNumber - periodStart;
  // After the two s-block columns the table jumps over the f-block (14 elements).
  return { row, column: offset < 2 ? offset + 1 : offset - 14 + 1 };
}

/**
 * The lanthanides and actinides are pulled out below the table so it isn't too wide.
 * Each family gets a marker in the gap it came from and a label on its own row.
 */
export const F_BLOCK_MARKERS = Object.freeze([
  {
    category: 'lanthanide',
    familyName: 'Lanthanides',
    range: 'La–Lu',
    gapPosition: { row: 6, column: 3 },
    labelPosition: { row: LANTHANIDE_ROW, column: '1 / span 2' },
  },
  {
    category: 'actinide',
    familyName: 'Actinides',
    range: 'Ac–Lr',
    gapPosition: { row: 7, column: 3 },
    labelPosition: { row: ACTINIDE_ROW, column: '1 / span 2' },
  },
]);
